// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueBus from 'vue-bus'
import * as cookies from "js-cookie";
Vue.use(VueBus)

import axios from 'axios'
Vue.prototype.$axios = axios

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import '../node_modules/basscss-basic/index.css'
import '../node_modules/basscss/css/basscss.css'
import 'animate.css'

import 'babel-polyfill'

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
    const name = cookies.get("fb_name");
    if(name){
        const userInfoInput = window.localStorage.getItem(name);
        if(to.name==="userInfoInput"&&userInfoInput){
            next({ path: "/" });
        }else if(to.name!=="userInfoInput"&&!userInfoInput){
            next({ path: "/userInfoInput" });
            return;
        }
    }
    if(to.name==="publishNews"||to.name==="userInfoInput"){
        if(!name){
            next({ path: "/" });
            return;
        }
    }
    next();
})
  
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js